import { render, staticRenderFns } from "./Finalise.vue?vue&type=template&id=7bfd836f&scoped=true"
import script from "./Finalise.vue?vue&type=script&lang=js"
export * from "./Finalise.vue?vue&type=script&lang=js"
import style0 from "./Finalise.vue?vue&type=style&index=0&id=7bfd836f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfd836f",
  null
  
)

export default component.exports